var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_382",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28855",
    "data-name": "Group 28855",
    transform: "translate(-4714 6451)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4714, -6451)",
    filter: "url(#Ellipse_382)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_382-2",
    "data-name": "Ellipse 382",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28847",
    "data-name": "Group 28847",
    transform: "translate(4468.316 -6431.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49694",
    "data-name": "Path 49694",
    d: "M281.77,28.173a14.086,14.086,0,1,0-14.086-14.086A14.1,14.1,0,0,0,281.77,28.173Zm0,0",
    fill: "#ffda2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49698",
    "data-name": "Path 49698",
    d: "M389.84,28.173A14.086,14.086,0,1,0,389.84,0Zm0,0",
    transform: "translate(-108.07)",
    fill: "#fdbf00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.94e3e9478b1e9720df39355e5cb6ff48.svg";
export { ForwardRef as ReactComponent };